var Backbone, EmailFormUSEmailDescriptionView, GrouponValidate, SupportEmailDescriptionTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GrouponValidate = require("../../../../../groupon/frontend/validate");

SupportEmailDescriptionTemplate = require('../../../../email_description.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

EmailFormUSEmailDescriptionView = (function(superClass) {
  extend(EmailFormUSEmailDescriptionView, superClass);

  function EmailFormUSEmailDescriptionView() {
    return EmailFormUSEmailDescriptionView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSEmailDescriptionView.prototype.events = {
    'customEvent .description': 'validateEmailForm',
    'keyup .description': 'validateEmailForm'
  };

  EmailFormUSEmailDescriptionView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.isInputFieldEmpty = true;
    this.elementID = ".description";
    this.template = SupportEmailDescriptionTemplate;
    this.model = this.options.model;
    this.label = I18n.t("js.modules.support.whatson");
    return this.isInputCompulsory = this.model.required;
  };

  EmailFormUSEmailDescriptionView.prototype.render = function() {
    return this.$el.html(toHtml(this.template, this.toHash()));
  };

  EmailFormUSEmailDescriptionView.prototype.toHash = function() {
    var flexibleStepThree, ref, ref1;
    flexibleStepThree = Groupon.Support.ContentModel.flexibleStepThree;
    return {
      placeholderText: flexibleStepThree != null ? (ref = flexibleStepThree.attributes) != null ? (ref1 = ref.description) != null ? ref1.placeHolder : void 0 : void 0 : void 0
    };
  };

  EmailFormUSEmailDescriptionView.prototype.isInputGiven = function() {
    return this.$el.find(this.elementID).val().trim().length > 0;
  };

  EmailFormUSEmailDescriptionView.prototype.readInput = function() {
    return this.$el.find(this.elementID).val().trim();
  };

  EmailFormUSEmailDescriptionView.prototype.isInputValid = function() {
    return this.validateDescription();
  };

  EmailFormUSEmailDescriptionView.prototype.validateEmailForm = function() {
    if (this.isInputCompulsory && ((this.isInputFieldEmpty && this.isInputGiven()) || !(this.isInputFieldEmpty || this.isInputGiven()))) {
      this.isInputFieldEmpty = !this.isInputGiven();
      return this.options.validateEmailForm();
    }
  };

  EmailFormUSEmailDescriptionView.prototype.populateInput = function(data) {
    var inputData;
    if (this.isInputGiven()) {
      inputData = this.readInput();
      return data.description += "\n\n " + this.label + " : " + inputData;
    }
  };

  EmailFormUSEmailDescriptionView.prototype.creditElement = function() {
    return this.$el.find('.credit_card_warning');
  };

  EmailFormUSEmailDescriptionView.prototype.validateDescription = function() {
    var isCreditInformation;
    isCreditInformation = GrouponValidate.creditCard(this.readInput());
    if (isCreditInformation) {
      this.creditElement().css('display', 'block');
    } else {
      this.creditElement().css('display', 'none');
    }
    return !isCreditInformation;
  };

  return EmailFormUSEmailDescriptionView;

})(Backbone.View);

module.exports = EmailFormUSEmailDescriptionView;

//# sourceMappingURL=data:application/json;base64,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
